<vdw-breadcrumb [(items)]="breadcrumbItems" (itemsChanged)="onBreadcrumbItemsChanged($event)" [disablePredicate]="disablePredicate"></vdw-breadcrumb>
